import { useMemo } from "react";
import { Column, TableState } from "./types";

export const useTableLogic = <T extends Record<string, any>>(data: T[], columns: Column<T>[], state: TableState<T>) => {
  // Filtrage et recherche
  const filteredData = useMemo(() => {
    let filtered = data;

    // Recherche globale
    if (state.searchTerm) {
      filtered = filtered.filter(row =>
        columns.some(col => {
          const value = row[col.key];
          return value?.toString().toLowerCase().includes(state.searchTerm.toLowerCase());
        })
      );
    }

    // Filtres par colonne
    Object.entries(state.columnFilters).forEach(([columnKey, filterValue]) => {
      if (filterValue) {
        filtered = filtered.filter(row => {
          const value = row[columnKey as keyof T];
          return value?.toString().toLowerCase().includes(filterValue.toLowerCase());
        });
      }
    });

    return filtered;
  }, [data, state.searchTerm, state.columnFilters, columns]);

  // Tri
  const sortedData = useMemo(() => {
    if (!state.sortColumn || !state.sortDirection) return filteredData;

    return [...filteredData].sort((a, b) => {
      const aValue = a[state.sortColumn!];
      const bValue = b[state.sortColumn!];

      if (aValue < bValue) return state.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return state.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredData, state.sortColumn, state.sortDirection]);

  return { filteredData, sortedData };
};
